<template>
  <div class="c-winelist">
    <v-dialog
      v-model="dialog"
      max-width="600px"
      v-if="hasRole('admin')"
      eager
    >
      <wine-edit
        ref="editor"
        v-on:dismissed="dialog = false"
        v-on:saved="dialog = false"
      ></wine-edit>
    </v-dialog>

    <v-row>
      <v-col>
        <div class="page-title">Liste des vins</div>
        <v-alert :value="!!error" type="error">
          {{ error }}
        </v-alert>
      </v-col>
    </v-row>


    <v-row justify="center">
      <v-col cols="auto">
        <v-btn
          color="primary"
          class="mb-2 mx-1"
          @click.stop="addItem"
        >
          Ajouter
        </v-btn>
        <v-btn
          color="primary"
          class="mb-2 mx-1"
          @click="exportWines"
          v-if="hasRole('admin')"
        >
          Exporter tous
          <v-icon right>save_alt</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="auto">
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          item-key="wine_id"
          disable-pagination
          disable-sort
          hide-default-footer
          class="elevation-1 transparent"
        >
          <template v-slot:item="{ item }">
            <tr class="c-winelist__tablerow" @click.stop="goToItem(item)">
              <td>{{ item._producer_name }}</td>
              <td>{{ item._color_name }}</td>
              <td>{{ item.data ? item.data.region: "" }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.data ? item.data.appellation: "" }}</td>
              <td>{{ item.data ? item.data.vintage : "" }}</td>
              <td>{{ item.reference }}</td>

              <td class="justify-center layout px-0">
                <v-tooltip bottom v-if="hasRole('admin')">
                  <template v-slot:activator="{ on }">
                    <v-btn icon class="mx-0" v-on="on" @click.stop="editItem(item)">
                      <v-icon color="teal">edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Editer</span>
                </v-tooltip>
                <v-tooltip bottom v-if="hasRole('admin')">
                  <template v-slot:activator="{ on }">
                    <v-btn icon class="mx-0" v-on="on" @click.stop="deleteItem(item)">
                      <v-icon color="pink">delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Supprimer</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import ExportAPI from '@/api/export';

import WineEdit from '@/components/WineEdit';

import CSVExport from '@/mixins/CSVExport';
import PeriodListener from '@/mixins/PeriodListener';
import RoleFiltering from '@/mixins/RoleFiltering';

import { WINE_DELETE, WINE_LIST } from '@/store/actions/wine';


export default {
  name: 'WineList',

  mixins: [
    CSVExport,
    PeriodListener,
    RoleFiltering
  ],

  components: {
    WineEdit
  },

  filters: {
  },

  data: () => ({
    loading: false,
    headers: [
      { text: 'Fournisseur', value: 'provider' },
      { text: 'Couleur du vin', value: 'color' },
      { text: 'Région', value: 'region' },
      { text: 'Nom du vin / domaine', value: 'name' },
      { text: 'Appellation', value: 'appellation' },
      { text: 'Millésime', value: 'vintage' },
      { text: 'Code article.', value: 'reference' },
      { text: 'Actions', value: 'actions', sortable: false }
    ],

    error: null,

    dialog: false
  }),

  computed: {
    ...mapState({
      items: state => state.wine.wines,
      defaultItem: state => state.wine.defaultItem
    })
  },

  mounted () {
    this.loading = true;
    this.$store.dispatch(WINE_LIST)
      .catch((err) => {
        this.$log.error(err);
        this.error = err.message;
      })
      .finally(() => {
        this.loading = false;
      });
  },

  methods: {
    addItem () {
      this.$refs.editor.edit(null);
      this.dialog = true;
    },
    editItem (item) {
      this.$refs.editor.edit(item);
      this.dialog = true;
    },
    goToItem (item) {
      this.$router.push({ name: 'wineDetail', params: { wineId: item.wine_id } });
    },
    deleteItem (item) {
      if (!confirm('Etes-vous sûr de vouloir supprimer ce vin ?')) {
        return;
      }

      this.$store.dispatch(WINE_DELETE, item.wine_id)
        .catch((err) => {
          this.$log.error(err);
          this.error = err.message;
        });
    },
    exportWines () {
      this.saveCSV(ExportAPI.getWines(), 'export_wines');
    }
  }
};
</script>

<style lang="scss" scoped>
.c-winelist {
  &__tablerow {
    cursor: pointer;
  }
}
</style>
